export default __webpack_public_path__ + "static/arcanum-patch-e421a404a14867ba3f17108d5eda62bf.webp";